import type { ClientOrganization } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';

import { OrganizationListItem } from '@/features/profile-setting/components/OrganizationListItem';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  organizations: ClientOrganization[];
  onSelect: (id: string) => void;
  describeOrganization?: (org: ClientOrganization) => string | undefined;
};

export const OrganizationSearchResultList: FC<Props> = ({
  organizations,
  onSelect,
  describeOrganization
}) => {
  const theme = useAppTheme();

  return (
    <>
      {organizations.map((org) => (
        <OrganizationListItem
          key={org.id}
          organization={org}
          description={describeOrganization?.(org)}
          onPress={() => onSelect(org.id)}
          backgroundColor={theme.colors.surfaceContainerLowest}
        />
      ))}
    </>
  );
};
